// eslint-disable-next-line import/no-extraneous-dependencies
import { encode } from 'js-base64'
export function encodeBase64(value: string) {
  return encode(value)
}
